import './App.scss';
import DeathNotificationMainLayout from 'components/layouts/DeathNotification/DeathNotificationMainLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import SubmissionError from 'components/layouts/Error/SubmissionError/SubmissionError';
import { browserHistory } from 'state/Store';

function App() {
  return (
    <div className="life-events">
      <BrowserRouter basename={'/usis/life-events'}
                     history={browserHistory}>
        <Routes>
          <Route path={'/'}
                 element={<Navigate replace
                                    to={'/death-notification'} />} />
          <Route path={'/death-notification'}
                 element={<DeathNotificationMainLayout />} />
          <Route path={'/death-notification/error'}
                 element={<SubmissionError />} />
        </Routes>
      </BrowserRouter>
    </div>);
}

export default App;
